<template>
	<span class="component theme-switcher">
		<form 
			method="post" 
			ref="themeForm"
			class="uk-form-stacked" 
			accept-charset="UTF-8" 
			autocomplete="off" 
			@submit.prevent="submitForm"
			>
			<input type="hidden" :name="csrfName" :value="csrfToken">	
			<input type="hidden" name="action" value="users/save-user">
			<input type="hidden" name="userId" :value="userId">
				<div>
					<button class="icons" type="button" :aria-label="isDarkMode ? 'Lichte weergave inschakelen' : 'Donkere weergave inschakelen'" @click="toggleSwitch">
						<span class="material-symbols-outlined icon dark" v-if="isDarkMode">
							<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z"/></svg>
						</span>
						<span class="material-symbols-outlined icon light" v-else>
							<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z"/></svg>
						</span>
					</button>
				</div>
		</form>
	</span>
</template>


<script>
	
import Cookies from 'js-cookie';
import axios from 'axios';

export default {
	name: "theme-switcher",
	props: {
		userId: {
			type: Number,
			default: 0,
		},
		dark: {
			type: Boolean,
			default: false
		} 
	},
	data() {
		return {
			formKey: null,
			isDarkMode: null,
			themeChangeHandler: null,
		};
	},
	computed: {
		csrfName() {
			return window.csrfTokenName;
		},
		csrfToken() {
			return window.csrfTokenValue;
		},
	},
	mounted() {
		
		var component = this;
		
		component.$logger("app/components/dark-mode-swich/mounted");
		
		component.formKey = "theme-switcher-" + component.$helper.getRandInteger();		
		
		if(component.dark) {
			component.isDarkMode = true;
		}	else {
			component.isDarkMode = false;
		}

		component.themeChangeHandler = function(event) {
			if (event.detail?.source === 'header-theme-switcher') {
				return;
			}

			if (typeof event.detail?.dark === 'boolean') {
				component.isDarkMode = event.detail.dark;
			}
		};
		window.addEventListener('nn:theme-change', component.themeChangeHandler);
	},
	beforeUnmount() {
		window.removeEventListener('nn:theme-change', this.themeChangeHandler);
	},
	created() {
		this.$logger("app/components/dark-mode-swich/created");
	},
	methods: {
		applyTheme() {

			var component = this;
						
			if (component.isDarkMode) {
				document.body.classList.add('dark');
				document.documentElement.classList.add('dark');
			} else {		
				document.body.classList.remove("dark");
				document.documentElement.classList.remove("dark");
			}

			window.dispatchEvent(new CustomEvent('nn:theme-change', {
				detail: { dark: component.isDarkMode, source: 'header-theme-switcher' }
			}));
		},
		toggleSwitch(e) {

			var component = this;
						
			if(component.isDarkMode) {
				component.isDarkMode = false;
			} else {
				component.isDarkMode = true;
			}			
			
			component.applyTheme();

			component.$logger("app/components/dark-mode-swich/toggleSwitch/isDarkMode: " + component.isDarkMode);

			// Set cookie
			Cookies.set('darkTheme', (component.isDarkMode) ? '1' : '0', { expires: 365 });
			
			// Submit form, or show notification for anonymous users
			if (component.userId > 0) {
				component.submitForm();
			} else {
				setTimeout(function () {
					component.$helper.confirmModal({
						title:
							"<h2>Tip van de dag</h2>Maak een gratis account aan en je voorkeur voor deze instelling wordt op ieder device/browser onthouden.<br><br>Wil je nu een account aanmaken?",
						onConfirm: function () {
							window.location = "/aanmelden";
						},
						onCancel: function () {},
					});
				}, 1000);
			}
							
		},
		submitForm() {

			var component = this;

			component.$logger("app/components/dark-mode-swich/submitForm");
						
			// Form data
			var form = component.$refs.themeForm;
			var formData = new FormData(form);
			
			// Custom data
			var data = {};
			
			// Add darkTheme value
			var fieldValue = (component.isDarkMode) ? '1' : '0';
			formData.append("fields[darkTheme]", fieldValue);
			
			// Request
			axios({
				method: "post",
				url: "/",
				responseType: "json",
				data: formData,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					Accept: "application/json",
				},
			})
			.then(function (response) {
				if (response.data.error) {
					// Error
					component.$logger("app/components/dark-mode-switch/response/error");
				} else {
					// Success
					component.$logger("app/components/dark-mode-switch/response/success");
				}
			})
			.catch(function (error) {
				component.$logger("app/components/dark-mode-switch/catch", "error");
				component.$logger(error?.response?.data?.message || error.message);

			});
		},
	},
}
</script>

<style scoped>
.component.theme-switcher {
	display: block;
	width: 44px;
	height: 44px;
	line-height: 0;
}
.component.theme-switcher form,
.component.theme-switcher form > div {
	display: block;
	width: 100%;
	height: 100%;
}
.component.theme-switcher .icons svg {
	display: block;
	width: 20px;
	height: 20px;
	fill: currentColor;
}
.component.theme-switcher .icons {
	display: grid;
	width: 44px;
	height: 44px;
	place-items: center;
	padding: 0;
	border: 0;
	border-radius: 999px;
	background: transparent;
	color: inherit;
	line-height: 0;
	cursor: pointer;
}
.component.theme-switcher .icons .icon {
	display: block;
	width: 20px;
	height: 20px;
	line-height: 0;
}
.component.theme-switcher .icons .light {
	width: 20px;
	height: 20px;
}

</style>
